import { ExternalLink } from "lucide-react";
import CaseImage from "@/components/CaseImage";

export default function CasePhotoGallery({ photos, showDriveFolderLink, driveLink, animalName, animalType }) {
  if (photos.length === 0 && !showDriveFolderLink) return null;

  return (
    <>
      <div className="flex gap-2 overflow-x-auto mb-2 -mx-1 px-1" data-testid="case-photo-gallery">
        {photos.length > 0 ? (
          photos.map((url) => (
            <CaseImage key={url} src={url} alt={animalName} animalType={animalType} className="h-56 w-56 shrink-0 rounded-2xl object-cover" />
          ))
        ) : (
          <CaseImage src={null} alt={animalName} animalType={animalType} className="h-56 w-56 shrink-0 rounded-2xl" />
        )}
      </div>
      {showDriveFolderLink && (
        <a
          href={driveLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="view-photos-on-drive-link"
          className="inline-flex items-center gap-1.5 text-sm text-amtm-teal font-semibold mb-4 hover:underline"
        >
          <ExternalLink className="h-4 w-4" /> View Photos on Drive
        </a>
      )}
    </>
  );
}
